import { IconChevronLeft } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import SettingsShell, { SETTINGS_ROOT, settingsGroups } from "@/modules/settings/SettingsShell";
import classes from "@/modules/settings/settings.module.css";
import { useGetImage } from "@/utilities/helper/getImage";
import useGetMerchant from "../hooks/useGetMerchant";

// Salon settings home: who the salon is, then the settings in two groups. «سایت و سئو» says how many of
// its fields are still empty.
function EditProfile() {
  const { data } = useGetMerchant();
  const { imageUrl } = useGetImage({ image: data?.logo, bucket: "merchant" });
  const info = data?.businessInfo;
  const seoMissing = [info?.seoTitle, info?.seoDescription, info?.englishName, info?.businessType, data?.cover?.fileName].filter((v) => !v).length;
  const site = info?.subDomain ? `${info.subDomain}.padix.ir` : undefined;

  return (
    <SettingsShell title="تنظیمات مجموعه" description="اطلاعاتی که مشتری‌ها روی سایت رزرو، در گوگل و در پیامک‌ها می‌بینند.">
      <div className={classes.hub}>
        <Link to={`${SETTINGS_ROOT}/merchantProfile`} className={`${classes.identity} ${classes.row}`}>
          {imageUrl ? <img src={imageUrl} alt="" /> : <span className={classes.avatar}>{info?.title?.charAt(0) ?? "؟"}</span>}
          <span className={classes.rowText}>
            <strong>{info?.title || "نام مجموعه"}</strong>
            <span dir="ltr" style={{ textAlign: "right" }}>{site ?? "آدرس سایت ثبت نشده"}</span>
          </span>
          <IconChevronLeft size={16} className={classes.chevron} />
        </Link>
        {settingsGroups.map((group) => (
          <div key={group.title} className={classes.group}>
            <span className={classes.groupTitle}>{group.title}</span>
            <div className={classes.list}>
              {group.items.map((item) => (
                <Link key={item.to} to={item.to} className={classes.row}>
                  <span className={classes.rowText}>
                    <strong>{item.title}</strong>
                    <span>{item.hint}</span>
                  </span>
                  {item.to.endsWith("/seo") && data && seoMissing > 0 && <span className={classes.badge}>{seoMissing.toLocaleString("fa-IR")} مورد خالی</span>}
                  <IconChevronLeft size={16} className={classes.chevron} />
                </Link>
              ))}
            </div>
          </div>
        ))}
      </div>
    </SettingsShell>
  );
}

export default EditProfile;
